import { useContext, useEffect } from 'react';

import { Address } from '@/components/Address/Address';
import { Layout } from '@/components/Layout/Layout';
import { Main } from '@/components/Main/Main';
import { Section } from '@/components/Section/Section';
// Components
import { Context } from '@/components/Store';
import { ActionTypes } from '@/components/Store.d';

/**
 * Address component
 * @returns {ReactElement}
 */
const AddressPage = () => {
  const [ , dispatch ] = useContext(Context);

  useEffect(() => {
    void (async () => {
      const { setTitle } = await import('@/lib/util');
      setTitle('Adresseingabe');
    })();

    dispatch({
      type: ActionTypes.setCurrentPage,
      payload: {
        key: 'currentPage',
        value: 'deliveryPage'
      }
    });

    dispatch({
      type: ActionTypes.showProductOnRight,
      payload: true
    });
  }, [ dispatch ]);

  return (
    <Layout className="layout-split">
      <Main>
        <Section className="section-delivery">
          <Address />
        </Section>
      </Main>
    </Layout>
  );
};

export default AddressPage;
